import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import classNames from 'classnames'

const BasePersistentModal = ({ children, open, onOpen, onClose }) => {
    const [isOpen, setIsOpen] = useState(false)

    useEffect(() => {
        setIsOpen(open)
    }, [open])

    useEffect(() => {
        if (isOpen) {
            document.querySelector('html').classList.add('overflow-hidden')
            if (onOpen) {
                onOpen()
            }
        } else {
            document.querySelector('html').classList.remove('overflow-hidden')
            if (onClose) {
                onClose()
            }
        }
    }, [isOpen, onOpen, onClose])


    const getRootElement = () => {
        let rootElement = document.querySelector('.js-persistent-modal-root')

        if (!rootElement) {
            rootElement = document.createElement('div')
            rootElement.classList.add('js-persistent-modal-root')
            document.body.appendChild(rootElement)
        }

        return rootElement
    }

    return isOpen
        ? createPortal(
            <div
                className={
                    classNames([
                        'fixed',
                        'top-0',
                        'left-0',
                        'w-screen',
                        'h-screen',
                        'bg-black',
                        'bg-opacity-25',
                        'flex',
                        'items-center',
                        'justify-center',
                        'overflow-auto',
                        'z-50'
                    ])
                }
            >
                <div
                    className={'max-w-screen max-h-screen'}>
                    {children}
                </div>
            </div>,
            getRootElement()
        )
        : null
}

BasePersistentModal.propTypes = {
    children: PropTypes.any,
    open: PropTypes.bool,
    onOpen: PropTypes.func,
    onClose: PropTypes.func
}

const PersistentModal = dynamic(() => Promise.resolve(BasePersistentModal), {
    ssr: false
})

export default PersistentModal 